import {
  DrawerFooterProps,
  DrawerHeaderProps,
  OrDrawerProps,
} from "./or-drawer.types";
import { AtButton, AtButtonSize, AtButtonType, AtIcon } from "../../atoms";
import { drawerHeaderVariants } from "./or-drawer-variants";
import { Drawer } from "@mui/material";
import { cx } from "class-variance-authority";
import { MlToast, MlToastProps } from "../../molecules";

export const CSCDrawerHeader: React.FC<DrawerHeaderProps> = ({
  title,
  subtitle,
  icon,
  actionButton,
  variant,
}: DrawerHeaderProps) => {
  return (
    <div className={drawerHeaderVariants({ variant })}>
      <div className="flex-1">
        <p className="font-semibold flex">
          {icon && <AtIcon name={icon} className="mr-1" />}
          {title}
        </p>
        {subtitle && <p className="text-normal mt-3">{subtitle}</p>}
      </div>
      {actionButton && (
        <AtButton
          {...actionButton}
          size={AtButtonSize.MEDIUM}
          buttonType={AtButtonType.SECONDARY}
          className="h-fit text-sm!"
        />
      )}
    </div>
  );
};

export const CSCFooterDrawer: React.FC<DrawerFooterProps> = ({
  mainButton,
  secondaryButton,
}: DrawerFooterProps) => {
  return (
    <div
      className={cx(
        "grid gap-5 w-full px-5 py-6",
        secondaryButton ? "grid-cols-2" : "grid-cols-1",
      )}
    >
      {secondaryButton && (
        <AtButton
          {...secondaryButton}
          size={AtButtonSize.NONE}
          buttonType={AtButtonType.SECONDARY}
          className="!py-3"
        />
      )}
      <AtButton
        {...mainButton}
        size={AtButtonSize.NONE}
        buttonType={AtButtonType.PRIMARY}
        className="!py-3"
      />
    </div>
  );
};

export const Header = ({ children }: { children: React.ReactNode }) => {
  return <header className="shadow-mid-center">{children}</header>;
};
export const Content = ({
  children,
  toast,
}: {
  children: React.ReactNode;
  toast?: MlToastProps;
}) => {
  return (
    <main className="flex-1 overflow-y-auto">
      {toast && <MlToast {...toast} />}
      <div className="p-4 h-full">{children}</div>
    </main>
  );
};
export const Footer = ({ children }: { children: React.ReactNode }) => {
  return <footer className="h-24 shadow-mid-center">{children}</footer>;
};

const SidebarWrapper = ({
  "data-testid": testId,
  children,
  isOpen = false,
  handleClose,
}: OrDrawerProps) => {
  return (
    <Drawer
      data-testid={testId}
      open={isOpen}
      onClose={handleClose}
      anchor="right"
    >
      <div className="flex flex-col h-screen overflow-y-hidden">{children}</div>
    </Drawer>
  );
};

export const OrDrawer = Object.assign(SidebarWrapper, {
  Header: Header,
  Content: Content,
  Footer: Footer,
});
